import React, { useEffect, useState } from 'react';
import { Menu, X, BookOpen } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface NavItem {
  id: string;
  label: string;
}
const navItems: NavItem[] = [{
  id: 'portada',
  label: 'Portada'
}, {
  id: 'introduccion',
  label: 'Introducción'
}, {
  id: 'capitulo-1',
  label: 'Capítulo 1: El Fuego Interno'
}, {
  id: 'capitulo-2',
  label: 'Capítulo 2: Los 5 Ladrones'
}, {
  id: 'capitulo-3',
  label: 'Capítulo 3: Farmacia Natural'
}, {
  id: 'capitulo-4',
  label: 'Capítulo 4: Protocolo 14 Días'
}, {
  id: 'capitulo-5',
  label: 'Capítulo 5: Drenaje y Sueño'
}, {
  id: 'anexos',
  label: 'Anexos y Recursos'
}, {
  id: 'precio',
  label: 'Obtén Tu Copia'
}];
export function SidebarNav({
  activeSection
}: {
  activeSection: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const totalScroll = document.documentElement.scrollTop;
      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scroll = `${totalScroll / windowHeight}`;
      setProgress(Number(scroll));
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80; // Account for mobile header
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsOpen(false);
  };
  return <>
      {/* Mobile Header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 h-16 bg-cream/95 backdrop-blur-sm border-b border-gold/20 z-50 flex items-center justify-between px-4" data-id="element-308">
        <div className="flex items-center gap-2 text-darkBrown font-serif font-semibold" data-id="element-309">
          <BookOpen className="w-5 h-5 text-gold" data-id="element-310" />
          <span data-id="element-311">Metabolismo Dorado</span>
        </div>
        <button onClick={() => setIsOpen(!isOpen)} className="p-2 text-darkBrown hover:text-gold transition-colors" aria-label="Toggle menu" data-id="element-312">
          {isOpen ? <X className="w-6 h-6" data-id="element-313" /> : <Menu className="w-6 h-6" data-id="element-314" />}
        </button>

        {/* Mobile Progress Bar */}
        <div className="absolute bottom-0 left-0 h-1 bg-gold/20 w-full" data-id="element-315">
          <div className="h-full bg-gold transition-all duration-150 ease-out" style={{
          width: `${progress * 100}%`
        }} data-id="element-316" />
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-317">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="lg:hidden fixed top-16 left-0 right-0 bottom-0 bg-cream z-40 overflow-y-auto border-t border-gold/10" data-id="element-318">
            <nav className="p-6 flex flex-col gap-4" data-id="element-319">
              {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className={`text-left text-lg py-2 transition-colors ${activeSection === item.id ? 'text-gold font-semibold' : 'text-darkBrown/70 hover:text-darkBrown'}`} data-id="element-320">
                  {item.label}
                </button>)}
            </nav>
          </motion.div>}
      </AnimatePresence>

      {/* Desktop Sidebar */}
      <div className="hidden lg:flex fixed top-0 left-0 w-72 h-screen bg-lightGold border-r border-gold/20 flex-col z-40" data-id="element-321">
        <div className="p-8 pb-4" data-id="element-322">
          <h2 className="font-serif text-2xl font-bold text-darkBrown leading-tight mb-2" data-id="element-323">
            Metabolismo
            <br data-id="element-324" />
            <span className="text-gold italic" data-id="element-325">Dorado</span>
          </h2>
          <p className="text-sm text-darkBrown/60" data-id="element-326">Plan de 14 Días</p>
        </div>

        <nav className="flex-1 overflow-y-auto px-6 py-4 flex flex-col gap-2" data-id="element-327">
          {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className={`text-left px-4 py-3 rounded-lg transition-all text-sm font-medium ${activeSection === item.id ? 'bg-gold/10 text-deepGold border-l-2 border-gold' : 'text-darkBrown/70 hover:bg-white/50 hover:text-darkBrown border-l-2 border-transparent'}`} data-id="element-328">
              {item.label}
            </button>)}
        </nav>

        {/* Desktop Progress */}
        <div className="p-6 border-t border-gold/10" data-id="element-329">
          <div className="flex justify-between text-xs text-darkBrown/60 mb-2" data-id="element-330">
            <span data-id="element-331">Progreso de lectura</span>
            <span data-id="element-332">{Math.round(progress * 100)}%</span>
          </div>
          <div className="h-1.5 bg-darkBrown/5 rounded-full overflow-hidden" data-id="element-333">
            <div className="h-full bg-gold transition-all duration-150 ease-out rounded-full" style={{
            width: `${progress * 100}%`
          }} data-id="element-334" />
          </div>
        </div>
      </div>
    </>;
}